import * as angular from "angular";
import {IPromise, IScope} from "angular";
import {Opportunity} from "../../model/Opportunity";
import {OpportunityAction} from "../../../opportunity_actions/model/OpportunityAction";
import './customerOpportunity.scss';
import {ActionService} from "../../../opportunity_actions_service/service/ActionService";
import {
    ACTION_SERVICE_NAME,
    CalculationNotificationServiceName,
    ToastNotificationServiceName
} from '../../../utils/names/serviceNames';
import {Subscription} from "rxjs";
import {CalculatorName} from "../../../calculations/model/Calculator";
import {LqbPricerResultDialog} from "../lqb_pricer_results_dialog/LqbPricerResultDialog";
import {CalculationsNotificationService} from "../../../opportunities_service/service/CalculationsNotificationService";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {LoggedInUserResolver} from "modules/users/resolver/LoggedInUserResolver";
import {Principle} from "modules/brand_service/model/Principle";

declare var require: (path: string) => string;

interface CustomerOpportunityScope extends IScope {
    opportunityActions: OpportunityAction[];
    opportunity: Opportunity;
    showEmailLoadingStatus: boolean;
    onEmailAction: (opportunityActionPromise: ng.IHttpPromise<OpportunityAction>) => void;
    onGenericAction: (opportunityActionPromise: ng.IHttpPromise<OpportunityAction>) => void;
    cancel: () => void;
    showLqbPricerResults: () => void;
    showActions: boolean;
    showLog: boolean;
    showActionTriggers: boolean;
    lqbPricingCalculation: boolean;
    triggerLeadsCalculation: boolean;
    eppraisalCalculation: boolean;
    principle: Principle;
}

export class CustomerOpportunityDialog implements ng.IComponentController {


    static instance = ($event: MouseEvent,
                       opportunity: Opportunity,
                       showLog: boolean = true,
                       showActionTriggers: boolean = true,
                       parent = document.body): angular.material.IDialogOptions => (
        {
            template: require('./customerOpportunity.html'),
            controller: [
                '$scope',
                ACTION_SERVICE_NAME,
                'opportunity',
                'showLog',
                'showActionTriggers',
                CalculationNotificationServiceName,
                '$mdDialog',
                ToastNotificationServiceName,
                'loggedInUser',
                CustomerOpportunityDialog
            ],
            parent: angular.element(parent),
            targetEvent: $event,
            clickOutsideToClose: true,
            fullscreen: true,
            resolve: {
                loggedInUser: LoggedInUserResolver.instance
            },
            locals: {
                opportunity: opportunity,
                showLog: showLog,
                showActionTriggers: showActionTriggers
            }
        }
    );

    constructor(private $scope: CustomerOpportunityScope,
                private actionService: ActionService,
                private opportunity: Opportunity,
                private showLog: boolean,
                private showActionTriggers: boolean,
                private calculationNotificationService: CalculationsNotificationService,
                private $mdDialog: angular.material.IDialogService,
                private tostNotificationService: ToastNotificationService,
                private loggedInUser: Principle) {
        this.$scope = Object.assign($scope, {
            showEmailLoadingStatus: false,
            cancel: this.cancel,
            onEmailAction: this.onEmailAction,
            onGenericAction: this.onGenericAction,
            opportunity: opportunity,
            showLog: showLog,
            showActionTriggers: showActionTriggers,
            showActions: showLog || showActionTriggers,
            lqbPricingCalculation: this.isLqbPricerCalculation(opportunity),
            showLqbPricerResults: this.showLqbPricerResults,
            triggerLeadsCalculation: this.isTriggerLeadsCalculation(opportunity),
            eppraisalCalculation: this.isEppraisalCalculation(opportunity),
            principle : loggedInUser
        })
    };

    private actionsSubscription: Subscription;


    $onInit(): void {
        this.actionService.findActions(this.$scope.opportunity.id)
            .then(resp => {
                if (resp.status === 200) {
                    this.$scope.opportunityActions = resp.data;
                } else {
                    this.tostNotificationService.generateErrorMessage("Failed to fetch oppportunity actions")
                }
            })
    }

    private showLqbPricerResults = ($event: MouseEvent) => {
        this.calculationNotificationService.getLqbExecutionsResultsForCalculation(this.$scope.opportunity.id)
            .then(resp => {
                this.$mdDialog.show(LqbPricerResultDialog.instance($event, resp.data))
            }, err => {
                this.tostNotificationService.generateErrorMessage("Failed to fetch calculation lqb execution results!");
            });
    };

    private isLqbPricerCalculation(opportunity: Opportunity): boolean {
        return opportunity.calculator.name == CalculatorName.SAVINGS || opportunity.calculator.name == CalculatorName.RATE_CALCULATOR;
    }
    private isTriggerLeadsCalculation(opportunity: Opportunity): boolean {
        return opportunity.calculator.name == CalculatorName.TRIGGER_LEADS;
    }
    private isEppraisalCalculation(opportunity: Opportunity): boolean {
        return opportunity.calculator.name == CalculatorName.EQUITY_CASH_OUT || opportunity.calculator.name == CalculatorName.EQUITY_RATE_AND_TERM_REFINANCE;
    }

    onEmailAction = (opportunityActionPromise: IPromise<OpportunityAction[]>): void => {
        this.$scope.showEmailLoadingStatus = true;
        opportunityActionPromise.then((data) => {
            data.forEach(o => this.$scope.opportunityActions.push(o));
            this.$scope.showEmailLoadingStatus = false;
        }, () => {
            this.$scope.showEmailLoadingStatus = false;
        }, err => {

        });
    };

    onGenericAction = (opportunityActionPromise: IPromise<OpportunityAction[]>) => {
        opportunityActionPromise.then((data) => {
            data.forEach(o => this.$scope.opportunityActions.push(o));
        }, () => {
        }, err => {

        });
    };

    $onDestroy(): void {
        this.actionsSubscription.unsubscribe();
    }

    cancel = () => {
        this.$mdDialog.cancel()
    };

}